import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { resetItemsAndPackagesSkus } from '../../../actions/reports/items-and-packages-skus';
import { fetchItemsAndPackagesSkus } from '../../../sagas/reports/items-and-packages-skus/routines';

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchItemsAndPackagesSkusHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('all', response.items, state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const resetItemsAndPackagesSkusHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchItemsAndPackagesSkusHandler(fetchItemsAndPackagesSkus),
  ...resetItemsAndPackagesSkusHandler(resetItemsAndPackagesSkus)
});
